import {
  type FlowGetPatientOrderBlockConfig,
  FlowGetPatientOrderBlockConfigSchema,
} from 'flow-schema';

import { BlockTextField } from '../../ConfigFields/TextField';
import { type BlockConfigProps } from '../../types';

function FormFields() {
  return (
    <BlockTextField
      fieldName="config.orderId"
      label="Test patientOrderId (leave empty to use provided entity)"
      helperText="Extract a patient order using the patientOrderID."
    />
  );
}

const documentationMarkdown = `
# Get Patient Order

Retrieve the full patient order record from the Notable database for the order with the specified id
`;

export const getPatientOrderConfig: BlockConfigProps<FlowGetPatientOrderBlockConfig> = {
  nodeHandles: [{ type: 'target' }, { type: 'source' }],
  defaultLabelPrefix: 'patientOrder',
  defaultConfig: {
    orderId: '',
  },
  configFields: {
    schema: FlowGetPatientOrderBlockConfigSchema,
    FormFields,
  },
  documentationMarkdown,
};
